import { Apis } from "../../config";
import apiService from "../ApiService";

export const createCallbackRequest = async (data) => {
    const result = await apiService.post(Apis.CreateCallbackRequest, data);
    if (result?.error) {
        return null;
    }
    return result;
}
